import { Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';

import { ApWindowService } from '@ap/cdk';

import { ErrorContext } from '../klant/login/error/error.model';

import { CHANGE_CREDENTIALS, ERROR, FORGOT_BROWSERCODE, LOGIN } from './mijn-login.constant';
import { MijnLoginService } from './mijn-login.service';

/**
 * @module MijnLoginModule
 * @ngdoc service
 * @name MijnLoginNavigation
 */
@Injectable({
    providedIn: 'root'
})
export class MijnLoginNavigation {
    public constructor(
        private readonly mijnLoginService: MijnLoginService,
        private readonly router: Router,
        private readonly windowService: ApWindowService
    ) {}

    public external(href: string, replaceState = false): void {
        if (replaceState) {
            this.windowService.getWindow().history.replaceState({}, 'login redirect', href);
            this.windowService.getWindow().history.go(0);
            this.windowService.location_reload();
        } else {
            this.windowService.location_href(href);
        }
    }

    public toLogin(): void {
        this.internal(LOGIN);
    }

    public toHomepage(): void {
        this.external('/');
    }

    public toChangeCredentials(): void {
        this.internal(CHANGE_CREDENTIALS);
    }

    public toForgotBrowsercode(): void {
        this.internal(FORGOT_BROWSERCODE);
    }

    public toError(context: ErrorContext = ErrorContext.ERROR): void {
        this.mijnLoginService.setErrorContext(context);
        this.internal(ERROR);
    }

    private internal(path: string): void {
        const navigationExtras: NavigationExtras = {
            queryParamsHandling: 'preserve'
        };
        this.router.navigate([path], navigationExtras);
    }
}
